export default {
	weddingIntro: 'Nos casamos!',

	// Wedding timer
	weddingTimer: {
		title: 'Desde o nosso “sim”',
		years_one: 'ano',
		years_other: 'anos',
		months_one: 'mês',
		months_other: 'meses',
		days_one: 'dia',
		days_other: 'dias',
		hours_one: 'hora',
		hours_other: 'horas',
		minutes_one: 'minuto',
		minutes_other: 'minutos',
		seconds_one: 'segundo',
		seconds_other: 'segundos',
		years_zero: 'anos',
		months_zero: 'meses',
		days_zero: 'dias',
		hours_zero: 'horas',
		minutes_zero: 'minutos',
		seconds_zero: 'segundos',
	},

	// Our Story
	ourStory: {
		part1:
			'Em 2015, nos conhecemos no primeiro dia da faculdade. Um Elton careca 👨‍🦲 e uma thais que não mudou nadinha (palavras dele) tiveram o primeiro contato.',
		part2:
			'2 anos depois, entre uma conversa e outra, sempre sobre coisas da faculdade ou Canadá 🇨🇦, os sentimentos começaram a se desenvolver. Pra Elton era simples, essa era a pessoa que ele imaginava se casando, cozinhando juntos e construindo uma família. Já Thais não tinha noção de tudo que Deus havia preparado para ela.',
		part3:
			'Graças a um bom amigo que deu uns empurrões, esses dois programadores tímidos (que desenvolveram juntos esse site 🤓) finalmente se aproximaram.',
		part4:
			'E assim, após 6 meses de oração e muita conversa, demos o primeiro beijo e começamos a namorar em março de 2017 🎉.',
		part5:
			'Não demorou pra se tornar nítido que Deus nos havia escolhido um para o outro, o amor foi só crescendo. Mas com o passar do tempo, também vieram momentos difíceis. Com muita paciência, carinho e a graça de Deus, nenhuma dificuldade foi capaz de nos separar, só nos fortalecemos e nos apaixonamos ainda mais um pelo o outro, nos tornamos melhores amigos. Fomos muito abençoados ao longo da nossa caminhada juntos, o grande sonho de ir ao Canadá que sempre compartilhávamos, virou realidade. Toda a luta, esforço e trabalho valeram a pena. No início de 2022, em fevereiro, finalmente realizamos o sonho do noivado 💍, e em julho nos casamos no civil.',
		part6:
			'Hoje, estamos montando a nossa primeira casinha (vulgo um mini apartamento em Toronto) juntos, cozinhando juntos, e logo estaremos oficialmente casados. O mês escolhido para o nosso grande dia é especial, pois é quando fazemos 6 anos de namoro e comemoramos mais um ano de vida de Elton, estamos muito animados para a chegada desse dia e muito felizes de podermos comemorar com tantos amigos e familiares queridos, esperamos vocês lá! ❤️',
	},

	// Gifts
	giftContent:
		'Sua presença é nosso maior presente! Mas, caso você também queira nos presentear com algo mais, criamos esta lista virtual com algumas coisinhas (Obs: moramos no Canadá, então não temos como receber presentes físicos 😬) e também cotas para a nossa lua de mel no México 🇲🇽 🏖️. Caso prefira fazer uma transferência diretamente, temos também as opções de PIX (🇧🇷) e Interac (🇨🇦). Desde já, nosso mais sincero agradecimento!',
}
